import {
    ContactContainer,
    Contacts,
    GoogleMaps,
} from "./contact.styles"
import phone from "../../assets/icons/phone.svg"
import location from "../../assets/icons/location-icon.svg"
import mail from "../../assets/icons/mail.svg"
import map from "../../assets/img/map.jpg"
import clock from "../../assets/icons/clock.svg"
import "./styles.scss"

const Contact = ({props}) => {
    return (
        <ContactContainer id="contacts">
            <h2>{props[1]}</h2>
            <Contacts>

                <ul>
                    <li className="contact-phones">
                        <img src={phone} alt=""/>
                        <a href="tel:+37378763821"><span>078 763 821</span></a>,<a href="tel:+37376513333"><span> 076 513 333</span></a>
                    </li>
                    <li>
                        <img src={mail} alt=""/>
                        <a href="mailto:drivemobile.contact@gmail.com"><span>drivemobile.contact@gmail.com</span></a>
                    </li>
                    <li>
                        <img src={location} alt=""/>
                        <span><a
                            href="https://maps.app.goo.gl/WSGVGQ5fK9QY2SVz8" target="_blank"
                            rel="noreferrer noopener">{props[2]}</a></span>
                    </li>
                    <li>
                        <img src={clock} alt=""/>
                        <span>{props[3]}</span>
                    </li>
                </ul>
            </Contacts>
            <a
                href="https://maps.app.goo.gl/WSGVGQ5fK9QY2SVz8"
                target="_blank"
                rel="noreferrer noopener"
            >
                <GoogleMaps>
                    <img src={map} alt=""/>

                </GoogleMaps>
            </a>
           {/*<div className="bank-details">
                <span className="bank-details_header">{props.requisites}</span>
                <div className="cols-wrapper">
                    <div className="left-col">
                    <span>"SOLTANAUTO-GRUP" SRL MD-2075 Moldova mun. Chișinău, str. N. Milescu-Spataru, 18, box nr. 429
c/f 1009600012003 TVA 0609720
IBAN MD66VI000002224614188MDL
BC "Victoriabank" SA Chișinău fil. 14</span>
                    </div>
                    <div className="right-col">
                    <span>c/b VICBMD2X446
                      CUIO 40611268
Director: Soltan Tudor 
Email: soltantudor@mail.ru
Tel.: 0692-92-229</span>
                    </div>
                </div>
            </div>
            {/* <Attention>
        <img src={attention} alt="" />
        {props[3]}
      </Attention> */}

        </ContactContainer>
    )
}

export default Contact
